import { render, staticRenderFns } from "./deposit-bonus.vue?vue&type=template&id=7ff74b6c"
import script from "./deposit-bonus.vue?vue&type=script&lang=js"
export * from "./deposit-bonus.vue?vue&type=script&lang=js"
import style0 from "./deposit-bonus.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/casino-banners/deposit-bonus.vue
// module id = NRsF
// module chunks = 0